import { reduxKey } from '../../constants';
export const getPage = (state)=>{
    var _state_reduxKey;
    return (_state_reduxKey = state[reduxKey]) === null || _state_reduxKey === void 0 ? void 0 : _state_reduxKey.page;
};
export const getPageName = (state)=>{
    var _getPage;
    return (_getPage = getPage(state)) === null || _getPage === void 0 ? void 0 : _getPage.name;
};
